import { X } from "lucide-react";
import { InboxContent } from "./Inbox";

export function InboxModal({ open, onClose, initialBloggerId, campaignId }: {
  open: boolean;
  onClose: () => void;
  initialBloggerId?: string;
  campaignId?: string;
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] grid place-items-center p-4"
      style={{ background: "rgba(28,28,28,0.55)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
    >
      <div
        className="bg-[var(--bg)] rounded-xl shadow-xl overflow-hidden flex flex-col fade-up"
        style={{ width: "min(960px, 96vw)", height: "min(85vh, 720px)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-ink-12 flex-shrink-0 bg-[var(--bg-2)]">
          <span className="font-display font-bold text-[16px] tracking-tight">Лента чатов</span>
          <button
            onClick={onClose}
            className="w-8 h-8 grid place-items-center rounded-md hover:bg-ink-6 text-ink-40 hover:text-ink"
          >
            <X size={16} />
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-hidden">
          <InboxContent initialBloggerId={initialBloggerId} campaignId={campaignId} />
        </div>
      </div>
    </div>
  );
}
